import React from "react";
import { formatJst } from "../lib/date";
import { profileLabelForRole } from "../lib/accessProfiles";
import { useLocalization } from "../hooks/useLocalization";
import { formatAuditAction } from "../lib/auditFormat";

export const AuditTimeline = ({ events }) => {
  const { t } = useLocalization();

  if (!events || events.length === 0) {
    return <p className="text-sm text-gray-500 py-8 text-center" data-testid="audit-empty">{t("common.noData")}</p>;
  }

  return (
    <div className="space-y-3" data-testid="audit-timeline">
      {events.map((event) => (
        <div key={event.id} className="flex items-start gap-3 border-l-2 border-blue-200 pl-4 py-1" data-testid={`audit-event-${event.id}`}>
          <div className="flex-1">
            <p className="text-sm font-semibold text-gray-800">{formatAuditAction(event.action, t)}</p>
            <p className="text-xs text-gray-500">
              {event.actor_name || profileLabelForRole(event.actor_role, t)} · {event.target_type} {event.employee_name ? `· ${event.employee_name}` : ""}
            </p>
            {event.reason && <p className="text-xs text-gray-500 mt-0.5">{event.reason}</p>}
          </div>
          <span className="text-xs text-gray-500 whitespace-nowrap">{formatJst(event.timestamp_jst)}</span>
        </div>
      ))}
    </div>
  );
};
